import { jsx } from "react/jsx-runtime";
import { useTheme } from "@mui/material";
import { BRANDCLUB_APP_CONFIG_ID } from "../../../utils/constants/Constants.js";
import { useBrandAppConfig } from "../../../api/cache/appConfigQueryOptions.js";
import { PdpProductInfoPartV1 } from "./PdpProductInfoPartV1.js";
import { PdpProductInfoPartV2 } from "./PdpProductInfoPartV2.js";
function PdpProductInfoPart({ part }) {
  const theme = useTheme();
  const { data: brandAppConfig } = useBrandAppConfig();
  const data = part.data;
  if (!(data == null ? void 0 : data.stacklineSku)) return null;
  const primaryColor = theme.palette.primary.main;
  const primaryContrastText = theme.palette.primary.contrastText;
  const appConfigId = brandAppConfig == null ? void 0 : brandAppConfig.appConfigId;
  if (appConfigId === BRANDCLUB_APP_CONFIG_ID) {
    return /* @__PURE__ */ jsx(
      PdpProductInfoPartV1,
      {
        data,
        primaryColor,
        primaryContrastText
      }
    );
  }
  return /* @__PURE__ */ jsx(
    PdpProductInfoPartV2,
    {
      data,
      primaryColor,
      primaryContrastText,
      appConfigId
    }
  );
}
export {
  PdpProductInfoPart
};
//# sourceMappingURL=PdpProductInfoPart.js.map
